/*
 * Copyright Camunda Services GmbH and/or licensed to Camunda Services GmbH under
 * one or more contributor license agreements. See the NOTICE file distributed
 * with this work for additional information regarding copyright ownership.
 * Licensed under the Camunda License 1.0. You may not use this file
 * except in compliance with the Camunda License 1.0.
 */

// @ts-nocheck TS2339
import styled, { keyframes } from 'styled-components';
import { TabList as CarbonTabList } from '@carbon/react';

import { Saving } from 'icons';
import { Button } from 'primitives';

export const ActionBarContainer = styled.header`
  border-bottom: 1px solid var(--silver-darken-87);
  background-color: var(--cm-color-white-base) !important;
`;

export const ActionBar = styled.header`
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-end;
  align-items: center;
  color: var(--cds-text-secondary, #525252);
`;

export const Separator = styled.span`
  width: 1px;
  height: 25px;
  background-color: var(--silver-darken-87);
  margin: 0 ${({ isDesignMode }) => (isDesignMode ? 'var(--spacing-small)' : 'var(--spacing-tiny)')} 0
    var(--spacing-tiny);
  display: inline-block;
`;

export const Left = styled.div`
  margin: 0 auto 0 15px;
  display: flex;
  align-items: center;

  & .cds--tabs {
    inline-size: auto !important;
    min-width: 245px;
  }
`;

export const Status = styled.div`
  user-select: none;
  display: inline-flex;
  width: 100%;
  font-size: 13px;
  color: var(--grey-darken-33);
  align-items: center;
  margin-left: 10px;

  > svg {
    margin-right: 3px;
  }

  &.warning {
    color: var(--cl-color-error);
  }
`;

export const Label = styled.label`
  cursor: ${({ disabled }) => (disabled ? 'default' : 'pointer')};
  margin-left: var(--spacing-medium);

  * {
    vertical-align: middle;
    cursor: inherit;
  }
`;

const spinning = keyframes`
  from {
    transform: rotate(0deg);
  }

  to {
    transform: rotate(180deg);
  }
`;

export const SavingIcon = styled(Saving)`
  animation: ${spinning} 1.5s linear infinite;
`;

export const PaddedContent = styled.div`
  display: flex;
  align-items: center;
  padding: var(--spacing-small) var(--spacing-tiny);
`;

export const TabList = styled(CarbonTabList)`
  user-select: none;
  height: 56px;
`;

export const ActionButton = styled(Button)`
  height: 30px;
  line-height: 30px;
  margin-right: var(--spacing-tiny);
  margin-left: var(--spacing-tiny);
  border-radius: 2px;
`;
